import GetArticleByIdRequestModelBase from '../_generated/modelBases/get-article-by-id-request-model-base';

export default class GetArticleByIdRequestModel extends GetArticleByIdRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
